import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../context/appContext";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Grid2, Typography } from "@mui/material";
import { AlertModalCheckIcon } from "../../../../assets";
import { AppLayout } from "../../../../containers/layout/app";
import { AddRoleWrapper } from "./styled";
import { BaseFieldSet } from "../../../../components/form/fieldset/styled";
import { BaseLabel } from "../../../../components/form/label/styled";
import { BaseInput } from "../../../../components/form/input/styled";
import { BaseButton } from "../../../../components/button/styled";
import { createRoleService } from "../../../../utils/api/usermanagement/role/createRole";
import { BaseAlertModal } from "../../../../components/modal/alert";

export const AddRole = () => {
    const cookies = new Cookies();
    const TOKEN = cookies.getAll().TOKEN;

    const navigate = useNavigate();
    const { setActiveNavItem } = useContext(AppContext);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
    const [formDetails, setFormDetails] = useState({
        title: "",
        description: "",
    });

    useEffect(() => {
        setActiveNavItem("User Management");
    }, [setActiveNavItem]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormDetails((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAlertModalPersist = () => {
        return setIsAlertModalOpen(true);
    };

    const handleAlertModalCallToActionClick = () => {
        setIsAlertModalOpen(false);
        return navigate(-1);
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);
        try {
            const response = await createRoleService(TOKEN, formDetails);
            if (response.status === "success") {
                setIsLoading(false);
                setIsAlertModalOpen(true);
            } else {
                setIsLoading(false);
                setError('Failed to update profile. Please check credentials and try again.');
            }
        } catch (error: any) {
            setIsLoading(false);
            setError(`Failed to update profile. ${error.message}`);
            console.error('Failed to update profile:', error);
        }
    };

    return (
        <AppLayout
            pageId={"User-Role"}
            pageTitle={"Add User Role"}
        >
            <AddRoleWrapper>
                {/* alert modal below */}
                <BaseAlertModal
                    open={isAlertModalOpen}
                    icon={<AlertModalCheckIcon />}
                    title="Add Role Successful"
                    message="Your information has been successfully added to the system."
                    callToAction="Back to Role"
                    handleClose={handleAlertModalPersist}
                    handleCallToAction={handleAlertModalCallToActionClick}
                />
                {/* alert modal above */}
                <Box>
                    <Typography
                        variant="h3"
                        fontFamily={"Poppins"}
                        fontWeight={500}
                        fontSize={18}
                        lineHeight={"normal"}
                        color="var(--text-salmon-pink-color)"
                    >
                        Enter required Information to add a role.
                    </Typography>
                </Box>
                <form
                    onSubmit={handleSubmit}
                >
                    <Grid2
                        container
                        component={"div"}
                        spacing={"var(--flex-gap)"}
                        className="fieldset-grid-wrapper"
                    >
                        <Grid2
                            size={{ mobile: 12 }}
                        >
                            <BaseFieldSet>
                                <BaseLabel
                                    colour="var(--dark-color)"
                                >
                                    Title
                                </BaseLabel>
                                <BaseInput
                                    required
                                    name="title"
                                    value={formDetails.title}
                                    placeholder="Title"
                                    onChange={(e) => handleChange(e)}
                                />
                            </BaseFieldSet>
                        </Grid2>
                        <Grid2
                            size={{ mobile: 12 }}
                        >
                            <BaseFieldSet>
                                <BaseLabel
                                    colour="var(--dark-color)"
                                >
                                    Description
                                </BaseLabel>
                                <BaseInput
                                    required
                                    multiline
                                    minRows={4}
                                    name="description"
                                    value={formDetails.description}
                                    placeholder="Description"
                                    onChange={(e) => handleChange(e)}
                                />
                            </BaseFieldSet>
                        </Grid2>
                    </Grid2>
                    {error && <Typography
                        fontFamily={"Inter"}
                        fontWeight={"600"}
                        fontSize={14}
                        lineHeight={"normal"}
                        color={"var(--text-salmon-pink-color)"}
                        whiteSpace={"normal"}
                    >
                        {error}
                    </Typography>}
                    <Box
                        overflow={"hidden"}
                    >
                        <BaseButton
                            type="submit"
                            variant="contained"
                            bgcolor="var(--primary-color)"
                            disableElevation
                            sx={{
                                width: { mobile: "100%", miniTablet: "auto" }
                            }}
                        >
                            {isLoading ? (
                                <CircularProgress color="inherit" className="loader" />
                            ) : (
                                <Typography
                                    variant={"button"}
                                    fontFamily={"inherit"}
                                    fontWeight={"inherit"}
                                    fontSize={"inherit"}
                                    lineHeight={"inherit"}
                                    color={"inherit"}
                                    textTransform={"inherit"}
                                >
                                    Submit
                                </Typography>
                            )}
                        </BaseButton>
                    </Box>
                </form>
            </AddRoleWrapper>
        </AppLayout>
    )
}